<template>
  <v-img
    contain
    :src="imgSRC"
    aspect-ratio="1/1"
    height="18"
    class="icon-style"
  ></v-img>
</template>

<script>
export default {
  props: {
    name: String,
  },
  data() {
    return {}
  },
  computed: {
    imgSRC() {
      return require('@/assets/images/' + this.name + '@3x.png')
    },
  },
}
</script>

<style lang="sass" scoped>
.icon-style
    margin: 3px
</style>
